import TableCellLink, { TableCellLinkProps } from "./CellLink";

export type TableCellSpaceProps = TableCellLinkProps;

const TableCellSpace = (props: TableCellSpaceProps) => {
  return <TableCellLink {...props} variant="primary" />;
};

TableCellSpace.displayName = "DS.Table.CellSpace";

export default TableCellSpace;
